import { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { useSettingsOverlay } from '../hooks/use-settings-overlay';
import { SettingsPanelOverlayHeader } from './settings-panel-overlay-header';

// TODO: Implement dismissal on escape key press
export const SettingsPanelOverlay = ({ children }: { children: React.ReactNode }) => {
  const { isOverlayVisible, resetOverlayVisibility } = useSettingsOverlay();

  // Reset overlay visibility on unmount
  useEffect(() => resetOverlayVisibility, [resetOverlayVisibility]);

  return (
    <AnimatePresence>
      {isOverlayVisible && (
        <motion.div
          className='composer-settings-panel-overlay'
          initial={{
            backgroundColor: 'rgba(0, 33, 82, 0)',
            backdropFilter: 'blur(0px)',
          }}
          animate={{
            backgroundColor: 'rgba(0, 33, 82, .2)',
            backdropFilter: 'blur(4px)',
          }}
          exit={{
            backgroundColor: 'rgba(0, 33, 82, 0)',
            backdropFilter: 'blur(0px)',
          }}
          transition={{
            type: 'tween',
            duration: 0.4,
            ease: 'easeOut',
          }}
          css={{
            height: '100%',
            left: 0,
            padding: theme.spacing(1),
            position: 'absolute',
            top: 0,
            width: '100%',
            zIndex: theme.zIndex.low,
          }}
        >
          <motion.div
            initial={{
              opacity: 0,
              y: '80%',
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              y: '80%',
            }}
            transition={{
              type: 'spring',
              stiffness: 275,
              damping: 22,
              mass: 0.9,
            }}
            css={{
              background: theme.colors.white,
              borderRadius: theme.borderRadius.medium,
              boxShadow: theme.shadows.floating,
              height: '100%',
              overflow: 'hidden auto',
            }}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

SettingsPanelOverlay.Header = SettingsPanelOverlayHeader;
